import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSrpTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "5.2 1.7 65.9 36.6",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42.8 14.1h3.8v1.2c1.2-1 2.7-1.5 4.4-1.5 4.1 0 7.3 3.4 7.3 7.8s-.7 3.9-1.9 5.2c-1.3 1.5-3.4 2.5-5.7 2.5s-2.8-.4-4-1.4v10.3h-4V14.1Zm4 9.7c.8 1.1 2.1 1.8 3.6 1.8 2.2 0 3.9-1.7 3.9-4.1s-1.5-4.1-3.8-4.1-2.9.7-3.7 1.8v4.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.5 21.6c0 7.3-5.7 13.2-12.7 13.2h-1.2v3.5h1.2c8.9 0 16.1-7.5 16.1-16.7v-6.5h-3.5v6.5ZM8.6 21.6c0-7.3 5.7-13.2 12.7-13.2h36.6V4.9H21.3c-8.9 0-16.1 7.5-16.1 16.7s7.2 16.7 16.1 16.7h18v-3.5h-18c-7 0-12.7-5.9-12.7-13.2M71.1 9.1l-2.4-2.5 2.4-2.4-2.4-2.5-2.5 2.5-2.4-2.5-2.5 2.5 2.5 2.4-2.5 2.5 2.5 2.4 2.4-2.4 2.5 2.4z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9 26c-1.5 0-3.1-.6-4.1-1.5l-1.9 2.9c1.8 1.3 3.9 2 6 2 3.1 0 5.9-1.8 5.9-4.6 0-5.2-7.2-4.4-7.2-6.3s.9-1.2 2-1.2 2.1.5 2.9 1l1.9-2.9c-1-.8-3.1-1.5-5-1.5-3 0-5.7 1.8-5.7 4.6 0 4.8 7.2 4 7.2 6.2S23.1 26 22 26ZM30.3 14.1V29h4v-9.4c.5-.9 1.9-2.2 3.6-2.2s1.2 0 1.4.2l.5-3.7c-.4 0-.8-.1-1.4-.1-1.8 0-3.4.7-4.3 1.8v-1.5z",
			fill: "currentColor"
		})
	]
});
export { SvgSrpTag as ReactComponent };
